import GdsLogoImage from '@/assets/img/gds-logo.svg';
import PyxisLogoImage from '@/assets/img/pyxis-portal-logo.png';
import './AuthCard.scss';

interface AuthCardProps {
  title: string;
  subtitle?: string;
}

export const AuthCard: React.FC<React.PropsWithChildren<AuthCardProps>> = ({
  title,
  subtitle,
  children,
}) => {
  return (
    <div className="auth-card__container">
      <div className="auth-card__logo-container">
        <img
          src={PyxisLogoImage}
          className="auth-card__logo"
          alt="Pyxis Portal Logo"
        />
        <img
          src={GdsLogoImage}
          className="auth-card__logo"
          alt="Gemini Diversified Services Logo"
        />
      </div>
      {subtitle && (
        <p className="auth-card__subtitle">{subtitle}</p>
      )}
      <h1 className="auth-card__title">{title}</h1>
      {children}
    </div>
  );
};
